let utils = {
    setContent(content){
        if(Array.isArray(content)) return content
        let reg = /\[audio=.*?\.mp3\]/g
        let txtArr = content.split(reg)
        let mp3Arr = content.match(reg)
        let arr = []
        txtArr.forEach((el,index)=>{
            arr.push({type:'stem',content:el})
            if(index!=txtArr.length-1){
                arr.push({type:'mp3',content:mp3Arr[index].split('=')[1].replace(']','')})
            }
        })
        return arr
    },
    trim(str){
        return str.replace(/(^\s*)|(\s*$)/g, "");
    },
    extend (defaults, options) {
        let extended = {};
        let prop;
        for (prop in defaults) {
            if (Object.prototype.hasOwnProperty.call(defaults, prop)) {
                extended[prop] = defaults[prop];
            }
        }
        for (prop in options) {
            if (Object.prototype.hasOwnProperty.call(options, prop)) {
                extended[prop] = options[prop];
            }
        }

        return extended;
    },
    /**
     * 日期格式化
     * 格式 YYYY/yyyy 表示年份
     * MM/M 月份
     * dd/DD/d/D 日期
     * @param {string} formatStr 格式模版
     * @returns 日期字符串
     */
    dateFormat (timeStamp, formatStr) {
        let str = formatStr
        let time = new Date(timeStamp * 1000)
        // 年
        str=str.replace(/yyyy|YYYY/, time.getFullYear());
        // 月
        str=str.replace(/MM/, (time.getMonth() + 1) > 9 ? (time.getMonth() +1 ).toString() : '0' + (time.getMonth() + 1));
        // 日
        str=str.replace(/dd|DD/, time.getDate() > 9 ? time.getDate().toString() : '0' + time.getDate());
        // 时
        str=str.replace(/HH|hh/, time.getHours() > 9 ? time.getHours().toString() : '0' + time.getHours());
        // 分
        str=str.replace(/MM|mm/, time.getMinutes() > 9 ? time.getMinutes().toString() : '0' + time.getMinutes());
        // 秒
        str=str.replace(/SS|ss/, time.getSeconds() > 9 ? time.getSeconds().toString() : '0' + time.getSeconds());
       return str;
    } ,
    regRelplace (reg, msg, callback) {
        // 工单<black>JY2018052900012</black>已被ceshi@system.com<black>催单</black>

        let content = msg.replace(reg,function(exp){

           return callback(exp)
           // return exp.replace(num,replaceNum);
        })
        return content;
    },
    getParams (name) {
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      let url = ''
      if (window.location.search) {
        url = window.location.search
      } else {
        url = '?' + window.location.href.split('?')[1]
      }
      const r = url.substr(1).match(reg)
      if (r != null) return unescape(r[2])
      return null
    }
}

export default utils



// WEBPACK FOOTER //
// ./common/assets/js/utils.js